import React from 'react';
import {Link, hashHistory} from 'react-router';
import { RaisedButton } from 'material-ui';
import {observable} from "mobx";

class HeaderTabs extends React.Component {

  @observable selectedTab = '';
  unMounted = false;

  componentWillMount(){
    const {onChangeTab, mobView} = this.props;
    hashHistory.listen(({pathname}) => {
      this.selectedTab = pathname.split('/')[1];
      if(mobView){
        switch(this.selectedTab){
          case '/': onChangeTab('Flood Forecasting Section'); break;
          case 'basin': onChangeTab('Real Time Data'); break;
          case 'current_forecast': onChangeTab('Current Forecast'); break;
          case 'flood_hazard_map': onChangeTab('Flood Hazard Map'); break;
          case 'community_outreach': onChangeTab('Community Outreach'); break;
          case 'projects': onChangeTab('Projects'); break;
          case 'publications': onChangeTab('Publications'); break;
          case 'river_watch': onChangeTab('River Watch'); break;
          case 'rainfall_watch': onChangeTab('Rainfall Watch'); break;
          default: onChangeTab('Flood Forecasting Section'); break;
        }
      }
      !this.unMounted && this.forceUpdate();
    })
  }

  componentWillUnmount(){
    this.unMounted = true;
  }

  onChangeTab = (tab) => {
    const {onChangeTab, toogleOpen, mobView} = this.props;
    if(mobView){
      toogleOpen();
      onChangeTab(tab);
    }
  };

  render() {
    const style = {borderRight:'0.5px lightgray solid', borderRadius:'0px !important',};
    const  labelStyle = {fontSize: '12px', fontWeight:'500 !important'};
    const {mobView} = this.props;
    if(mobView) style.width = '250px';
    return (
      <div className="tabs">
        <Link to="/" onClick={() => this.onChangeTab('Flood Forecasting Section')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Home' primary={this.selectedTab === ''}/></Link>{' '}
        <Link to="/basin" onClick={() => this.onChangeTab('Real Time Data')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Real Time Data' primary={this.selectedTab === 'basin'}/></Link>{' '}
        <Link to="/river_watch" onClick={() => this.onChangeTab('River Watch')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='River Watch' primary={this.selectedTab === 'river_watch'}/></Link>{' '}
        <Link to="/rainfall_watch" onClick={() => this.onChangeTab('Rainfall Watch')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Rainfall Watch' primary={this.selectedTab === 'rainfall_watch'}/></Link>{' '}
        <Link to="/current_forecast" onClick={() => this.onChangeTab('Current Forecast')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Current Forecast' primary={this.selectedTab === 'current_forecast'}/></Link>{' '}
        <Link to="/flood_hazard_map" onClick={() => this.onChangeTab('Flood Hazard Map')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Flood Hazard Map' primary={this.selectedTab === 'flood_hazard_map'}/></Link>{' '}
        <Link to="/community_outreach" onClick={() => this.onChangeTab('Community Outreach')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Community Outreach' primary={this.selectedTab === 'community_outreach'}/></Link>{' '}
        <Link to="/projects" onClick={() => this.onChangeTab('Projects')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Projects' primary={this.selectedTab === 'projects'}/></Link>{' '}
        <Link to="/publications" onClick={() => this.onChangeTab('Publications')}><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Publications' primary={this.selectedTab === 'publications'}/></Link>{' '}

        {/*<a href="http://daq.hydrology.gov.np/river_watch" target="_blank" rel="noopener noreferrer"><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='River Watch'/></a>{' '}*/}
        {/*<a href="http://daq.hydrology.gov.np/rainfall_watch" target="_blank" rel="noopener noreferrer"><RaisedButton labelStyle={labelStyle} buttonStyle={style} label='Rainfall Watch'/></a>{' '}*/}
      </div>
  );
  }
}

export default HeaderTabs;



// WEBPACK FOOTER //
// ./src/components/common/Tabs.js